import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const addAdminPurchaseOrder = createAsyncThunk(
    "/admin/create-admin-po",
    async (payload, { rejectWithValue }) => {
        try {
            const myurl = `${V_URL}/believe/create-po`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                toast.success(data.message || "Purchase Order created successfully");
                return data;
            } else {
                toast.error(data.message || "Failed to create Purchase Order");
                return rejectWithValue(data);
            }
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Something went wrong";
            toast.error(message);
            return rejectWithValue(error.response?.data || message);
        }
    }
);

const addAdminPurchaseOrderSlice = createSlice({
    name: "addAdminPurchaseOrder",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetAddPo: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addAdminPurchaseOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addAdminPurchaseOrder.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addAdminPurchaseOrder.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetAddPo } = addAdminPurchaseOrderSlice.actions;
export default addAdminPurchaseOrderSlice.reducer;
